import fetch, {getBlob2} from '../utils/fetch';

export function indexCards(params) {
  return fetch({
    method: 'POST',
    url: '/report/indexCards',
    data:params
  })
}

export function sortCheckinRate(params) {
  return fetch({
    method: 'POST',
    url: '/report/sortCheckinRate',
    data:params
  })
}
export function vacancyDays(params) {
  return fetch({
    method: 'POST',
    url: '/report/vacancyDays',
    data:params
  })
}
export function funnelConversionRate(params) {
  return fetch({
    method: 'POST',
    url: '/report/funnelConversionRate',
    data:params
  })
}
export function checkinRateList(params) {
  return fetch({
    method: 'POST',
    url: '/report/checkinRateList',
    data:params
  })
}
export function surrenderRate(params) {
  return fetch({
    method: 'POST',
    url: '/report/surrenderRate',
    data:params
  })
}
export function answerRate(params) {
  return fetch({
    method: 'POST',
    url: '/report/answerRate',
    data:params
  })
}
export function checkinRateListForHouse(params) {
  return fetch({
    method: 'POST',
    url: '/report/checkinRateListForHouse',
    data:params
  })
}
export function answerRateGroupByZo(params) {
  return fetch({
    method: 'POST',
    url: '/report/answerRateGroupByZo',
    data:params
  })
}
export function followInTimeRate(params) {
  return fetch({
    method: 'POST',
    url: '/report/followInTimeRate',
    data:params
  })
}
export function followInTimeRateGroupByZo(params) {
  return fetch({
    method: 'POST',
    url: '/report/followInTimeRateGroupByZo',
    data:params
  })
}
export function findReturnRateList(params) {
  return fetch({
    method: 'POST',
    url: '/report/findReturnRateList',
    data:params
  })
}
export function reportflow(params) {
  return fetch({
    method: 'POST',
    url: '/report/flow',
    data:params
  })
}
export function downLoadFollowInTimeRateList(params) {
  return getBlob2({
    method: 'POST',
    url: '/report/downLoadFollowInTimeRateList',
    data:params
  })
}
export function downLoadAnswerRateList(params) {
  return getBlob2({
    method: 'POST',
    url: '/report/downLoadAnswerRateList',
    data:params
  })
}
export function downloadCheckinRateList(params) {
  return getBlob2({
    method: 'POST',
    url: '/report/downloadCheckinRateList',
    data:params
  })
}
export function getPersonLonAndLat(params) {
  return fetch({
    method: 'POST',
    url: '/report/getPersonLonAndLat',
    params
  })
}

export function getLonAndLatForShow(params) {
  return fetch({
    method: 'POST',
    url: '/report/getLonAndLatForShow',
    params
  })
}

export function getProjectLonAndLat(params) {
  return fetch({
    method: 'POST',
    url: '/report/getProjectLonAndLat',
    params
  })
}


// 获取房型浏览记录
export function getBrowseHistoryList(params) {

  return fetch({
    method: 'POST',
    url: '/report/getBrowseHistoryList',
    params
  })
}



// 获取房型收藏记录
export function getHouseTypeCollectionList(params) {

  return fetch({
    method: 'GET',
    url: '/report/housetype/collection',
    params
  })
}

// 获取房型收藏记录
export function getHouseTypeCollectionCount(params) {

  return fetch({
    method: 'GET',
    url: '/report/housetype/collection/count',
    params
  })
}

//获取房型租客历史
export function getHouseTypeContractList(params) {

  return fetch({
    method: 'GET',
    url: '/report/housetype/contract',
    params
  })
}

//获取房型租客历史数量
export function getHouseTypeContractCount(params) {

  return fetch({
    method: 'GET',
    url: '/report/housetype/contract/count',
    params
  })
}

//获取房型租客历史
export function getHouseTypeBrowseList(params) {

  return fetch({
    method: 'GET',
    url: '/report/housetype/location',
    params
  })
}

//获取房型租客历史
export function getHouseTypeBrowseCount(params) {

  return fetch({
    method: 'GET',
    url: '/report/housetype/location/count',
    params
  })
}
